/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ItemType } from './';
import {
    ItemTypeFromJSON,
    ItemTypeFromJSONTyped,
    ItemTypeToJSON,
} from './';
import type { Photo } from './';
import {
    PhotoFromJSON,
    PhotoFromJSONTyped,
    PhotoToJSON,
} from './';
import type { PortfolioItem } from './';
import {
    PortfolioItemFromJSON,
    PortfolioItemFromJSONTyped,
    PortfolioItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioPhoto
 */
export interface PortfolioPhoto extends PortfolioItem {
    /**
     * 
     * @type {Photo}
     * @memberof PortfolioPhoto
     */
    photo?: Photo;
}

/**
 * Check if a given object implements the PortfolioPhoto interface.
 */
export function instanceOfPortfolioPhoto(value: object): value is PortfolioPhoto {
    return true;
}

export function PortfolioPhotoFromJSON(json: any): PortfolioPhoto {
    return PortfolioPhotoFromJSONTyped(json, false);
}

export function PortfolioPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioPhoto {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...PortfolioItemFromJSONTyped(json, ignoreDiscriminator),
        'photo': json['photo'] == null ? undefined : PhotoFromJSON(json['photo']),
    };
}

export function PortfolioPhotoToJSON(value?: PortfolioPhoto | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...PortfolioItemToJSON(value, true),
        'photo': PhotoToJSON(value['photo']),
    };
}

